import constants from '../components/new-auth/config/constants'; // this should be lifted

export const IsValidEmail = (potentialEmail: string): boolean => {
  return constants.regex.email.test(potentialEmail.trim());
};
